import React from "react";
import IntegrationConfigurationService from "./IntegrationConfigurationService";
import {Button, Col, Row} from "react-bootstrap";

class IntegrationConfigurationGrid {
  title = 'Configuração de Integração';
  columns = [
    {
      Header: "ID",
      accessor: "id"
    },
    {
      Header: "Opções",
      sortable: false,
      filterable: false,
      export: false,
      Cell: row => (
          <Row>
            <Col lg={12}>
              <a href={"#/integration-configurations/" + row.original.id + "/edit"}>
                <Button bsStyle="success" block>Editar</Button>
              </a>
            </Col>
          </Row>
      ),
    }
  ];
  endpoint = IntegrationConfigurationService.ALL_URL;
}

export default IntegrationConfigurationGrid;



// WEBPACK FOOTER //
// ./src/integration/configuration/IntegrationConfigurationGrid.js